import React, { Component } from 'react';
import ContactForm from 'auth0-contact-form';

class Hero extends Component {
  componentDidMount() {
    this.createContactForm();
  }

  createContactForm() {
    /* eslint-env browser */
    const metricsLib = window.metricsLib;
    const mouseFlow = window.mouseflow || undefined;
    const salesContactFormOptions = {
      onModalOpen() {
        metricsLib.track('click:contact-sales');
      },
      onFormSuccess(metricsData) {
        metricsLib.track('register:lead:resources-contact-form', metricsData);
        mouseFlow ? mouseFlow.formSubmitSuccess('#contact-form-modal__form') : null;
      },
      onFormFail(metricsData) {
        metricsLib.track('fail:register:lead:resources-contact-form', metricsData);
        mouseFlow ? mouseFlow.formSubmitFailure('#contact-form-modal__form') : null;
      },
      source: 'resources-page'
    };
    this.salesContactForm = new ContactForm(salesContactFormOptions);
  }

  contactUsHandler = () => {
    this.salesContactForm.show();
  };

  render() {
    return (
      <div className="hero-wrapper">
        <div className="container">
          <div className="row vertical-align ">
            <div className="col-xs-12 col-md-6">
              <h1 className="hero-title">Resources</h1>
              <p className="hero-subtitle">
                Learn how we secure and solve the most complex identity use cases with an extensible, easy to integrate platform that powers trillions of logins every year.
              </p>
              <div className="btn-container">
                <a href="javascript:signup()" className="btn btn-success btn-lg">
                  Use auth0 for free
                </a>
                <button
                  onClick={this.contactUsHandler}
                  className="btn btn-transparent btn-lg js-general-contact-sales open-contact-form-modal"
                >
                  Contact us
                </button>
              </div>
            </div>
            <div className="col-md-6 hidden-xs hidden-sm">
              <img
                className="hero-image"
                src="https://cdn.auth0.com/website/assets/pages/resources/img/hero-illustration-2-23ebe524c6.svg"
                alt="resources"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/pages/resources/components/Hero/Hero.js